import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-savingsgeneralsettings',
  templateUrl: './savingsgeneralsettings.component.html',
  styleUrls: ['./savingsgeneralsettings.component.css']
})
export class SavingsgeneralsettingsComponent implements OnInit {

  @Output() saveForm = new EventEmitter();
  @Input('product') product = {
    INVESTMENT_CATEGORY_ID: '0',
    INVESTMENT_SUB_CATEGORY_ID: '0',
    INVESTMENT_AMOUNT: '2',
    SAVINGS_PRODUCT_ID: '0',
    INVESTMENT_MAX_AMOUNT: '0',
    TENOR: '3',
    MAX_INVESTMENT_DURATION: '',
    LOAN_INTEREST: '0',
    LOAN_INTERVAL: '0',
    DURATION_INTERVAL: '0',
    LOAN_INTEREST_TYPE: '0',
    LOAN_DURATION_TYPE: '0',
    INTEREST_PERIOD_ID	:'2',
    INVESTMENT_PERIODIC_ID:'2',
    DAYS_PER_YEAR:'365',
    LOAN_TITLE:'',
    LOAN_DESCRIPTION:'',
  };
  @Input('loading') loading = false;
  @Input('loan_duration') loan_duration = 'Months';
  @Input('interest_duration') interest_duration = 'Per Month';
  public loan_durations = [
    { 'LOAN_INTEREST_DURATION_ID': '1', 'LOAN_DURATION': 'Days', 'INTEREST_DURATION': 'Per Day', 'ADJECTIVAL': 'Daily', 'ABBREV': 'd' },
    { 'LOAN_INTEREST_DURATION_ID': '2', 'LOAN_DURATION': 'Months', 'INTEREST_DURATION': 'Per Month', 'ADJECTIVAL': 'Monthly', 'ABBREV': 'Mo' },
    { 'LOAN_INTEREST_DURATION_ID': '3', 'LOAN_DURATION': 'Years', 'INTEREST_DURATION': 'Per Year', 'ADJECTIVAL': 'Yearly', 'ABBREV': 'Yr' },
    { 'LOAN_INTEREST_DURATION_ID': '4', 'LOAN_DURATION': 'Weeks', 'INTEREST_DURATION': 'Per Week', 'ADJECTIVAL': 'Weekly', 'ABBREV': 'Wk' }
  ];
  constructor() { }

  ngOnInit() {

  }
  changeMaxDuration(d, T) {
    this.loan_duration = this.loan_durations[d]['LOAN_DURATION'];
    this.product.LOAN_DURATION_TYPE = this.loan_durations[d]['LOAN_INTEREST_DURATION_ID'];
    this.product.INVESTMENT_PERIODIC_ID = this.loan_durations[d]['LOAN_INTEREST_DURATION_ID'];
  }
  changeDuration(d, T) {

    if (T === 2) {
      this.interest_duration = this.loan_durations[d]['INTEREST_DURATION'];
      this.product.LOAN_INTEREST_TYPE = this.loan_durations[d]['LOAN_INTEREST_DURATION_ID'];
      this.product.INTEREST_PERIOD_ID = this.loan_durations[d]['LOAN_INTEREST_DURATION_ID'];
    }

  }
  saveInvestmentProduct(value, valid) {
    this.saveForm.emit({ value: value, valid: valid });
  }
}
